// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
import { PasscodeType } from './custom-types.js';
const createGuard = z.object({
    id: z.string().max(21),
    interactionJti: z.string().max(128),
    phone: z.string().max(32).nullable().optional(),
    email: z.string().max(128).nullable().optional(),
    type: z.nativeEnum(PasscodeType),
    code: z.string().max(6),
    consumed: z.boolean().optional(),
    tryCount: z.number().optional(),
    createdAt: z.number().optional(),
});
const guard = z.object({
    id: z.string().max(21),
    interactionJti: z.string().max(128),
    phone: z.string().max(32).nullable(),
    email: z.string().max(128).nullable(),
    type: z.nativeEnum(PasscodeType),
    code: z.string().max(6),
    consumed: z.boolean(),
    tryCount: z.number(),
    createdAt: z.number(),
});
export const Passcodes = Object.freeze({
    table: 'passcodes',
    tableSingular: 'passcode',
    fields: {
        id: 'id',
        interactionJti: 'interaction_jti',
        phone: 'phone',
        email: 'email',
        type: 'type',
        code: 'code',
        consumed: 'consumed',
        tryCount: 'try_count',
        createdAt: 'created_at',
    },
    fieldKeys: [
        'id',
        'interactionJti',
        'phone',
        'email',
        'type',
        'code',
        'consumed',
        'tryCount',
        'createdAt',
    ],
    createGuard,
    guard,
});
